<template>
  <div class="basic-layout">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'BasicLayout',
}
</script>

<style>
.basic-layout {
  width: 100%;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/BasicLayout.vue